import { removeFalsy } from "helpers/formatter";
import { Protocol } from "models/protocol";
import apiService from "modules/api/apiService";
import { PROTOCOL_CRUD, PROTOCOL_LIST } from "modules/api/endpoint";
import { TPagination } from "modules/api/type";

export const getProtocolList = async (
  params: any
): Promise<{
  success: boolean;
  data?: any[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(`${PROTOCOL_LIST}${queryParams ? `?${queryParams}` : ""}`);

    //Update the model with a boolean variable to use on front end
    results.data.payload.data = results.data.payload.data.map((e) => {
      e.is_fitlinxx_standard = e.allow_update === 0;
      //Update display value for lift/drop times (they include decimal points that are not saved in db)
      e.min_lift_time_for_display = e.min_lift_time / 100;
      e.min_drop_time_for_display = e.min_drop_time / 100;
      return e;
    });

    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const getProtocolById = async (
  params: any
): Promise<{
  success: boolean;
  data?: Protocol;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(`${PROTOCOL_CRUD}${queryParams ? `?${queryParams}` : ""}`);

    //Update the model with a boolean variable to use on front end
    let entry = results.data.payload[0];
    entry.is_fitlinxx_standard = entry.allow_update === 0;
    //Update display value for lift/drop times (they include decimal points that are not saved in db)
    entry.min_lift_time_for_display = entry.min_lift_time / 100;
    entry.min_drop_time_for_display = entry.min_drop_time / 100;

    return {
      data: entry,
      success: true, //results.data.payload[0],
    };
  } catch (error) {
    return { success: false };
  }
};

export const addProtocolEntry = async (
  body: any
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    let result = await apiService.post(PROTOCOL_CRUD, body);
    return {
      data: result,
      success: true,
    };
  } catch (e) {
    return {
      message: e.message,
      success: false,
    };
  }
};

export const updateProtocolEntry = async (
  body: any
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    let result = await apiService.put(PROTOCOL_CRUD, body);
    return {
      data: result,
      success: true,
    };
  } catch (e) {
    return {
      message: e.message,
      success: false,
    };
  }
};

export const deleteProtocolEntry = async (id: number) => {
  return apiService.del(`${PROTOCOL_CRUD}?id=${id}`);
};
